import classNames from "classnames";
import React from "react";

export const InformationLoadingRow = ({
  className,
}: {
  className?: string;
}) => {
  return (
    <div
      className={classNames(
        "activity-row flex-center shimmer-wrapper",
        className,
      )}
    >
      <div className="icon shimmer" />
      <div className="flex-1">
        <div className="top-row flex-baseline spread">
          <div className="title shimmer" />
          <div className="value shimmer" />
        </div>
        <div className="bottom-row flex-baseline spread">
          <div className="desc shimmer" />
          <div className="subvalue shimmer" />
        </div>
      </div>

      <style jsx>{`
        .activity-row {
          .shimmer {
            margin: 0;
            border-radius: 0.25rem;
          }

          .icon {
            border-radius: 50%;
            width: 2.5rem;
            height: 2.5rem;
            margin-right: 0.75rem;
          }

          .top-row {
            margin-bottom: 0.75rem;
          }

          .title {
            width: 40%;
            height: 0.75rem;
          }

          .value {
            width: 25%;
            height: 0.75rem;
          }

          .desc {
            width: 25%;
            height: 0.625rem;
          }

          .subvalue {
            width: 15%;
            height: 0.625rem;
          }
        }
      `}</style>
    </div>
  );
};
